import { render } from "./SceneConstructor.vue?vue&type=template&id=122ac26f&ts=true"
import script from "./SceneConstructor.vue?vue&type=script&lang=ts"
export * from "./SceneConstructor.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__